export enum Environment {
  Production = 'prod',
  Stage = 'stage',
  Development = 'development',
}
